import { ROUTES } from '@/lib/constants/routes';
import { DATA_ROOM_RETURN_PARAMS } from './constants';

/**
 * Where "Open" goes for a startup's data room or Issue Report: the handoff
 * page, with the startup in the query string because router state does not
 * cross into the new tab it opens in (MYN-164). The launch behind it is still
 * entitlement-checked by the backend.
 */
export function dataRoomHandoffHref(startupId: string): string {
  return `${ROUTES.DATA_ROOM_HANDOFF}?${new URLSearchParams({ [DATA_ROOM_RETURN_PARAMS.STARTUP_ID]: startupId })}`;
}
